import React, { useCallback, useRef, useEffect, useState } from 'react';

import { IconType } from 'react-icons/lib';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import api from '../../services/api';
import { date, hour, dateLanguage } from '../../utils/date';
import { Container } from './styles';

interface IProgram {
  date: Date;
  formatted_date?: string;
  start_hour: Date;
  formatted_start_hour?: string;
  end_date: Date;
  formatted_end_date?: string;
  title: string;
  room_reference_id_response: Record<string, any>;
}

interface IProgramFilter {
  formatted_date: string;
  program: Array<IProgram>;
}

const Program: React.FC = () => {
  const [programs, setPrograms] = useState<Array<IProgramFilter>>([]);
  const [currentDay, setCurrentDay] = useState(0);

  useEffect(() => {
    const load = async () => {
      const program_ref: Array<IProgramFilter> = [];

      const response = await api.get('/programs-list');
      if (response && response.data && response.data.rows) {
        const responseData = response.data.rows.reduce((prev, elem) => {
          elem.formatted_date = dateLanguage(elem.date);
          elem.formatted_start_hour = hour(elem.start_hour);
          elem.formatted_end_hour = hour(elem.end_hour);
          prev.push(elem);

          return prev;
        }, []);


        if (responseData) {
          responseData.map(rep => {
            const index = program_ref.findIndex(
              day => day.formatted_date === rep.formatted_date,
            );

            if (index < 0) {
              program_ref.push({
                formatted_date: rep.formatted_date,
                program: [{ ...rep }],
              });
            } else {
              program_ref[index].program.push({ ...rep });
            }
          });
        }

        setPrograms(program_ref);
      }
    };
    load();
  }, []);

  const line = program => {
    return (
      <tr>
        <td>
      
          <p dangerouslySetInnerHTML={{__html : program.description}} />
          
        </td>
      </tr>
    );
  };
  const {length} = programs;
  return (
    <Container>
<h2>PROGRAMAÇÃO</h2>
      {programs[currentDay] &&
<>
          <div className="programDayHeader" >
            {' '}
            {currentDay > 0 ? <button type="button" onClick={() => setCurrentDay(currentDay - 1)} className="defaultButtonMini">
              {' '}
              <FiChevronLeft />{' '}
            </button> : <span/>}
         

            {(currentDay < (length - 1)) ?
            <button type="button" className="defaultButtonMini" onClick={() => setCurrentDay(currentDay + 1) }>
              {' '}
              <FiChevronRight />{' '}
            </button> : <span/>}
          </div>
          <table>
            {' '}
            <tbody>{programs[currentDay].program.map(items => line(items))}</tbody>
          </table>
        </>
}
    </Container>
  );
};
export default Program;
